import { render, staticRenderFns } from "./news-link.vue?vue&type=template&id=726d56b7&scoped=true"
import script from "./news-link.vue?vue&type=script&lang=js"
export * from "./news-link.vue?vue&type=script&lang=js"
import style0 from "./news-link.vue?vue&type=style&index=0&id=726d56b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d56b7",
  null
  
)

export default component.exports